import React from "react";
import Dashboard from "./Dashboard.js";
import information from "../../assets/information.png";
import "./DashboardCommon.css";

const FollowersDashboard = ({ index, dashboardText, handleDashboardClick, handleArrowClick, dataList }) => {
  return (
    <>
      <div className="header_flex">
        <h4 className="header_title">Followers</h4>
        <img className="header_image" src={information} alt="information" />
        <p className="header_description">Total number of new followers</p>
      </div>
      <div className="dashboard_div">
        <Dashboard
          type={index}
          ListType={dashboardText}
          monthList={dataList?.month}
          dayList={dataList?.day}
          weekList={dataList?.week}
        />
      </div>
      <div className="divider_div4" />
    </>
  );
};

export default FollowersDashboard;
